import { ReactElement } from 'react';

import { Box } from '@twilio-paste/core/box';
import { Heading } from '@twilio-paste/core/heading';
import { Stack } from '@twilio-paste/core/stack';

import { useExperiment } from '../../hooks';
import { WISE_OWL_FEATURE_FLAG } from '../../definitions/constants';
import ReactHelmet from '../reactHelmet';
import PageLoader from '../pageLoader';
import { ArticlesByProduct } from './sub';
import { WiseOwlView } from '../wiseOwlView';
import { copy } from './definitions';

import styles from './landing.module.css';

const Landing = (): ReactElement => {
  const { isOn: shouldRenderWiseOwl, isLoadingTreatment } = useExperiment({
    experimentName: WISE_OWL_FEATURE_FLAG,
  });

  if (isLoadingTreatment) {
    return <PageLoader />;
  }

  if (shouldRenderWiseOwl) {
    return <WiseOwlView />;
  }

  return (
    <Box as="main" className={styles.container}>
      <ReactHelmet title={copy.reactHelmet.title} />
      <Stack orientation="vertical" spacing="space110">
        <Box as="section">
          <Heading as="h3" variant="heading30" marginBottom="space0">
            {copy.browseArticlesByProduct.heading}
          </Heading>

          <ArticlesByProduct />
        </Box>
      </Stack>
    </Box>
  );
};

export default Landing;
